/** @jsxImportSource theme-ui */

import React from 'react';
import { ResponsiveStyleValue } from 'theme-ui';
import { AllCaroteneColors, PaddingProps, ShadowProps, StackProps, StyleOverrideProps } from '../utils/types';

type AlignItemsType = 'normal' | 'stretch' | 'center' | 'start' | 'end' | 'baseline';

export interface ContainerProps
    extends StackProps,
        PaddingProps,
        ShadowProps,
        StyleOverrideProps,
        Omit<React.ComponentPropsWithRef<'div'>, 'css'> {
    borderRadius?: ResponsiveStyleValue<string>;
    alignItems?: ResponsiveStyleValue<AlignItemsType>;
    background?: AllCaroteneColors;
    width?: ResponsiveStyleValue<number | string>;
    maxWidth?: ResponsiveStyleValue<number | string>;
    minWidth?: ResponsiveStyleValue<number | string>;
    maxHeight?: ResponsiveStyleValue<number | string>;
    minHeight?: ResponsiveStyleValue<number | string>;
    height?: ResponsiveStyleValue<number | string>;
    as?: 'div' | 'aside' | 'main' | 'section' | 'nav';
}

export default function Container(props: ContainerProps): JSX.Element {
    const {
        width,
        maxWidth,
        minWidth,
        height,
        maxHeight,
        minHeight,
        borderRadius,
        background,
        shadow,
        stack,
        alignItems,
        padding,
        paddingLeftRight,
        paddingTopBottom,
        sx,
        as: Component,
        ...otherProps
    } = props;

    return (
        <Component
            sx={{
                height,
                maxHeight,
                minHeight,
                width,
                maxWidth,
                minWidth,
                padding,
                alignItems,
                borderRadius,
                boxShadow: shadow,
                backgroundColor: background,
                paddingLeft: paddingLeftRight,
                paddingRight: paddingLeftRight,
                paddingTop: paddingTopBottom,
                paddingBottom: paddingTopBottom,
                marginBottom: stack,
                boxSizing: 'border-box',
                ...sx,
            }}
            {...otherProps}
        />
    );
}

Container.defaultProps = {
    padding: 'none',
    stack: 'none',
    shadow: 'none',
    height: 'auto',
    as: 'div',
};
